import React from 'react';
import { DownloadIcon } from './Icons';

export function ModalDownloadButton({ children = 'Download', ...rest }) {
  return (
    <button className="ci-modal-download-btn" type="button" {...rest}>
      <DownloadIcon className="ci-modal-download-btn__icon" alt="" /> {children}
    </button>
  );
}
